import { combineReducers } from 'redux';
import { orderReducer } from './order/reducers';
import { selectedServicesReducer } from './selectedServices/reducers';
import servicesSavingReducer from './servicesLoading/reducer';
export const rootReducer = combineReducers({
    order: orderReducer,
    selectedServices: selectedServicesReducer,
    servicesLoading: servicesSavingReducer
});
